import React from 'react'

export default function ProductCard({props}: any) {
    return (
        <div className="product__card">
            <h2 className="product__name">{props.name}</h2>
            <img src={props.photo} className="product__image"/>
            <div className="product__details">
                <div className="product__buy">
                    <div className="product__price">{Math.round( props.price ).toFixed(2)}$</div> <button className="button--light product__button">add to cart</button>
                </div>
                <div className="product__description">{props.description}</div>

            </div>
        </div>
    )
}
